import { useCallback, useEffect, useState } from 'react';
import { supabase } from '../services/supabaseClient';

const sources = [
  { key: 'lent', table: 'lent', returnTable: 'lent_returns', foreignKey: 'lent_id' },
  { key: 'safekeeping', table: 'safe_keeping', returnTable: 'safe_returns', foreignKey: 'safe_id' },
  { key: 'savings', table: 'savings', returnTable: 'savings_returns', foreignKey: 'saving_id' }
];

const emptySummary = {
  lent: 0,
  safekeeping: 0,
  savings: 0,
  openItems: 0,
  loading: true
};

export function useTrackerSummary(userId) {
  const [summary, setSummary] = useState(emptySummary);

  const refresh = useCallback(async () => {
    if (!userId) {
      setSummary({ ...emptySummary, loading: false });
      return;
    }

    const next = { lent: 0, safekeeping: 0, savings: 0, openItems: 0, loading: false };

    await Promise.all(sources.map(async (source) => {
      const { data: records, error } = await supabase
        .from(source.table)
        .select('id, amount')
        .eq('user_id', userId);

      if (error || !records?.length) return;

      const ids = records.map((record) => record.id);
      const { data: returns } = await supabase
        .from(source.returnTable)
        .select(`amount, ${source.foreignKey}`)
        .in(source.foreignKey, ids);

      const returnedById = (returns || []).reduce((totals, item) => {
        const id = item[source.foreignKey];
        totals[id] = (totals[id] || 0) + Number(item.amount || 0);
        return totals;
      }, {});

      records.forEach((record) => {
        const remaining = Math.max(Number(record.amount || 0) - Number(returnedById[record.id] || 0), 0);
        next[source.key] += remaining;
        if (remaining > 0) next.openItems += 1;
      });
    }));

    setSummary(next);
  }, [userId]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { ...summary, refresh };
}
